import { defineMessages } from 'react-intl'

export default defineMessages({
  copied: {
    id: 'components.CopyToClipboard.copied',
    defaultMessage: 'copied',
    description: '请修改',
  },
})
